import { createModule } from 'terrific-singleton';
import { TerrificSpec } from 'terrific-singleton/terrific-module';

const classes = {
	stateExpanded: 'm-expansion-panel--expanded',
	contentWrapper: 'm-expansion-panel--content-wrapper',
};

@createModule('ExpansionPanel')
/**
 * expansion-panel
 *
 */
export class ExpansionPanel extends TerrificSpec {
	$ctx: JQuery; 

	start(resolve: () => void) {
		this.$ctx = $(this._ctx);

		this.initExpansionPanel();
		this.$ctx.on('click', this.togglePanel.bind(this));
		this.panelAnchorClick();

		resolve();
	}

	initExpansionPanel() {
		const $panelHead = this.$ctx;
		$panelHead.each((index, element) => {
			const $this = $(element);
			if (!$this.hasClass(classes.stateExpanded)) {
				$this.next().addClass(classes.contentWrapper);
			}
		});
	}
	togglePanel(ev: Event) {
		const $this = $(ev.currentTarget)
		if ($this.hasClass(classes.stateExpanded)) {
			$this.removeClass(classes.stateExpanded);
			$this.next().removeClass(classes.contentWrapper).slideUp();
		} else {
			$this.addClass(classes.stateExpanded);
			$this.next().removeClass(classes.contentWrapper).slideDown();
		}
	}
	panelAnchorClick() {
		const panelID = this.$ctx.attr('data-anchor-id');
		$('.o-header__sticky-bar').on("click",'[href="#' + panelID + '"]',() => {
			this.$ctx.next().slideDown();
			this.$ctx.addClass(classes.stateExpanded);
		});
	}

	stop() { }
}
